import script from "./PandoraFooter1.vue?vue&type=script&setup=true&lang=js"
export * from "./PandoraFooter1.vue?vue&type=script&setup=true&lang=js"

import "./PandoraFooter1.vue?vue&type=style&index=0&id=ced28ca2&lang=css"

const __exports__ = script;

export default __exports__